<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      坳背站<br>
站点介绍<br>
坳背站位于龙岗区红棉路与坳背路交叉口处,车站主体沿红棉路呈南北走向，南接四联站，北接大运站。坳背站色彩基调以树干暖色调为主，装修设计“阳光+”生长的线路主题，整体空间色彩通过“白色”、“木色”、“绿色系”进行组合，体现14号线阳光+生长绿意盎然的生态特色主题空间。车站为地下二层车站，地下一层为站厅层，地下二层为站台层，站台形式为双岛式站台。车站设置有4个出入口，临近坳背村，周边以居民区、厂房为主。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:32	23:30	14号线	4分30秒	6分15秒<br>
沙田	06:24	23:54	14号线	4分30秒	6分15秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:30	23:30	14号线	5分25秒	6分15秒<br>
沙田	06:24	23:54	14号线	5分25秒	6分15秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:30	00:30	14号线	5分钟	6分15秒<br>
沙田	06:24	00:54	14号线	5分钟	6分15秒<br><br>

站点出口信息<br><br>
A出入口:<br>
红棉路东侧<br><br>
B出入口:<br>
坳背路北侧，坳背市场<br><br>
C出入口:<br>
红棉路西侧，坳二村<br><br>
D出入口:<br>
坳背路南侧，坳一村，坳中小区<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 坳背市场<br>
930<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shisihaoxian",
            title: "14号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>